const language = 'english'; //'russian';
export const langDir = 'ltr';

export default language;
